export default __webpack_public_path__ + "static/media/Research.cd6197a9.png";